import React, { useCallback, useEffect, useMemo, useRef } from "react";
import { useQuestContext } from "../context/QuestContext";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@bandit-network/react-ui-kit";

const QuestProgress = () => {
  const { quest, tasksCompleted, tasksList } = useQuestContext();

  const progressRef = useRef<HTMLDivElement>();

  const totalTasksCompleted = useMemo(
    () => tasksCompleted?.length,
    [tasksCompleted],
  );

  const modulePositions = useMemo(() => {
    // Step 1: Count the number of tasks for each moduleId
    const tasksCountByModule = (tasksList || [])?.reduce((acc, item) => {
      const { moduleId } = item;
      acc[moduleId] = (acc[moduleId] || 0) + 1;
      return acc;
    }, {});

    // Step 2: Calculate the percentage for each moduleId
    const totalTasks = tasksList?.length;

    const taskCountModuleArray = Object.keys(tasksCountByModule);
    const percentageByModule = {};
    for (let i = 0; i < taskCountModuleArray.length; i++) {
      const count = tasksCountByModule[taskCountModuleArray[i]];
      const _ = (count / totalTasks) * 100;
      const percentage =
        i !== 0 ? percentageByModule[taskCountModuleArray[i - 1]] + _ : _;
      percentageByModule[taskCountModuleArray[i]] = Math.floor(percentage);
    }
    return percentageByModule;
  }, [tasksList]);

  const getModuleRewardCount = useCallback(
    (moduleId) => {
      const module = quest?.contestMetaData?.find((m) => m.id === moduleId);
      return module?.rewardData?.count;
    },
    [quest],
  );

  useEffect(() => {
    if (progressRef.current) {
      progressRef.current.style!.width = `${
        (totalTasksCompleted / tasksList?.length) * 100
      }%`;
    }
  }, [totalTasksCompleted, tasksList]);

  return (
    <div className="bad-quest__progress--content">
      <div className="bad-quest__progress">
        {Object.keys(modulePositions).map((module, i) => (
          <TooltipProvider key={i}>
            <Tooltip>
              <TooltipTrigger
                className={`bad-quest__progress--checkpoint--static`}
                style={{
                  left: `${modulePositions[module]}%`,
                }}
              >
                <div className={`bad-quest__progress--checkpoint`}></div>
                <TooltipContent>
                  <p className="text-xs">
                    Checkpoint {i + 1} :{" "}
                    <span className="font-medium">
                      {getModuleRewardCount(module)} XP
                    </span>
                  </p>
                </TooltipContent>
              </TooltipTrigger>
            </Tooltip>
          </TooltipProvider>
        ))}

        <div
          ref={progressRef}
          className={`bad-quest__progress--current`}
          style={{
            background: `rgba(34, 197, 94, 1)`,
          }}
        ></div>
      </div>
    </div>
  );
};

export default QuestProgress;
